import pinia from "../Plugins/pinia";
import { useAuthStore } from "../Store/auth"

export default function auth({ to, from, next }) {
    const authStore = useAuthStore(pinia)

    if (to.meta.requiresAuth && !authStore.isLoggedIn) {
        return next({ name: 'choose-role' })
    }

    next()
}
